/**
 * アプリケーション設定
 *
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business UX Mirrorアプリ設定。API URL・言語設定・TanStack Queryデフォルト値を定義
 * @graph-connects none
 */

export const config = {
  /** API base URL */
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api',

  /** アプリケーション名 */
  appName: 'UX Mirror',

  /** デフォルト言語 */
  defaultLanguage: 'ja',

  /** サポート言語 */
  supportedLanguages: ['ja', 'en'] as const,

  /** TanStack Query のデフォルト設定 */
  query: {
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  },
} as const;

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business サポート対象言語コードの型を定義する
 * @graph-connects none
 */
export type SupportedLanguage = (typeof config.supportedLanguages)[number];
